import Base from "./base";

export default class EspertoPay extends Base {
	makeExternalPayment(newStep) {
		this.props.externalFunc.makeDeposit(
			{
				amount: parseInt(this.state.stake),
				currency: this.state.selectedCurrency,
				method: this.props.externalFunc.method,
				claimsBonus: false,
			},
			(data) => {
				this.setState({
					externalUrl: data.payment_url,
					currentStep: newStep,
				});
			}
		);
	}

	makeExternalPaymentWithBonus(newStep, bonusId) {
		this.props.externalFunc.makeDeposit(
			{
				amount: parseInt(this.state.stake),
				claimsBonus: true,
				bonusId: bonusId,
				currency: this.state.selectedCurrency,
				method: this.props.externalFunc.method,
			},
			(data) => {
				this.setState({
					externalUrl: data.payment_url,
					currentStep: newStep,
				});
			}
		);
	}
}
